
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToDemo = () => {
    const demoSection = document.getElementById('demo-section');
    if (demoSection) {
      window.scrollTo({
        top: demoSection.offsetTop - 80,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'py-3 bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-200/50' 
          : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-2">
            <div className="w-8 h-8 rounded-md bg-gradient-to-tr from-wamy-600 to-teal-500 flex items-center justify-center">
              <span className="text-white font-bold">W</span>
            </div>
            <span className="text-xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-wamy-600 to-teal-600">
              Wamy
            </span>
          </a>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#product" className="text-sm text-gray-700 hover:text-wamy-600 transition-colors">
              Product
            </a>
            <a href="#how-it-works" className="text-sm text-gray-700 hover:text-wamy-600 transition-colors">
              How It Works
            </a>
            <a href="#benefits" className="text-sm text-gray-700 hover:text-wamy-600 transition-colors">
              Benefits
            </a>
            <Button 
              size="sm"
              className="bg-gradient-to-r from-wamy-600 to-teal-500 hover:from-wamy-700 hover:to-teal-600 text-white shadow-md hover:shadow-lg transition-all"
              onClick={scrollToDemo}
            >
              Request Demo
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden focus:outline-none"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile navigation */}
      {isMenuOpen && (
        <div className="md:hidden pt-2 pb-4 px-4 bg-white/95 backdrop-blur-lg border-b border-gray-200/50 shadow-sm">
          <nav className="flex flex-col space-y-4">
            <a 
              href="#product" 
              onClick={() => setIsMenuOpen(false)} 
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            >
              Product
            </a>
            <a 
              href="#how-it-works" 
              onClick={() => setIsMenuOpen(false)} 
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            >
              How It Works
            </a>
            <a 
              href="#benefits" 
              onClick={() => setIsMenuOpen(false)} 
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            >
              Benefits
            </a>
            <Button 
              className="bg-gradient-to-r from-wamy-600 to-teal-500 hover:from-wamy-700 hover:to-teal-600 text-white w-full"
              onClick={scrollToDemo}
            >
              Request Demo
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
